import * as React from 'react';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import { useSelector, useDispatch } from 'react-redux';
import LinearProgress from '@mui/material/LinearProgress';
import Button from '@mui/material/Button';
import { useNavigate } from "react-router-dom";
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import uuid from 'react-uuid';
import Alert from '@mui/material/Alert';

import { useEffect, useRef ,useState } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import BeenhereIcon from '@mui/icons-material/Beenhere';
import CancelIcon from '@mui/icons-material/Cancel';
import Tooltip from '@mui/material/Tooltip';
import DataGrid from 'react-data-grid';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CheckIcon from '@mui/icons-material/Check';
import historyicon from '../assets/images/historyicon.png'
import moneyicon from '../assets/images/moneyicon.png'
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { addComma, removeComma, separateNumber } from '../helpers/mmg';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { textAlign } from '@mui/system';
import Divider from '@mui/material/Divider';
import productbrand from '../assets/images/productbrand.png'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { ChangeRXOrderState, resetRXOrderResultBox, setRXOrderConsumer, setRXOrderDateMustDelivered, setRXOrderDescription, setRXOrderPayType, setRXOrderStoreName, setRXPreviewItemsDialogClose, submitOrderPayment, submitRXOrder } from '../slices/rxorder.slice';
import PrintIcon from '@mui/icons-material/Print';
import { testThe } from '../slices/storder.slice';
import { getReportURL } from '../api';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));


export const zeroPad = (num, places) => String(num).padStart(places, '0');


const mdTheme = createTheme({

  typography: {
    fontFamily: [
      "mohammadfont",
      "Tahoma",
      "Verdana"
    ].join(",")
  },
  
  direction: 'ltr',
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: '#FBC02D',
          color: '#424242'
        },
      },
    },
  }
});


export const RXPreviewItems = () => {
  

  const [open, setOpen] = React.useState(false);
  const [openApprove, setOpenApprove] = React.useState(false);
  const [openDeny, setOpenDeny] = React.useState(false);

  const handleYes = () => {
    setOpen(false);
    

    dispatch(submitRXOrder({ rxOrder : rxOrder , authUser}));
    

    
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleNo = () => {
    setOpen(false);
  };

  const consumerRef = useRef();
  const descriptionRef = useRef();
  const storeNameRef = useRef();


  const dispatch = useDispatch();
  //const { user: authUser } = useSelector(x => x.auth);
  const authUser = JSON.parse(localStorage.getItem('user'));

  const rxOrder = useSelector(x => x.rxOrder);
  //const matrix = useSelector(x => x.matrix.itemsToAddFromMatrix);
  const defaultValues1 = useSelector(x => x.defaultValue);
  const defaultValues = JSON.parse(localStorage.getItem('defaultValue'));


  let navigate = useNavigate();
 
  const columns = [
    {
      name: 'ردیف',
      key: 'RowNumber',
      flex: 1
    }, 
    {
      key: 'ProductTitle',
      name: ' محصول',
      width: '37%',
      resizable: true,
      sortable: true,
      flex: 1
    },
    {
      key: 'ProductCode',
      name: 'کد محصول ',
      width: '10%',
      resizable: true,
      sortable: true,
      flex: 1
    },
    {
      key: 'Quantity',
      name: 'تعداد',
      width: '6%',
      resizable: true,
      sortable: true,
      flex: 1,
      formatter(props) {
        return <span>{addComma(props.row.Quantity.toString())}</span>
      }
    },
    {
      key: 'Fee',
      name: 'فی',
      width: '12%',
      resizable: true,
      sortable: true,
      flex: 1,
      formatter(props) {
        return <span>{addComma(props.row.Fee.toString())}</span>
      }
    },
    {
      key: 'Discount',
      name: 'تخفیف',
      width: '8%',
      resizable: true,
      sortable: true,
      flex: 1,
      formatter(props) {
        return <span>{authUser.role === "CustomerPortal" || authUser.role === "Personnel" ? addComma(props.row.Discount.toString()) : ''}</span>
      }
    },
    {
      key: 'Price',
      name: 'قیمت',
      width: '12%',
      resizable: true,
      sortable: true,
      flex: 1,
      formatter(props) {
            return <span>{addComma(props.row.Price.toString())}</span>
      }
    }
  ];

  const stateHistoryCols = [
    {
      name: 'ردیف',
      key: 'RowId'
    }, 
    {
      key: 'SrcState',
      name: ' وضعیت مبدا',
      width: '15%'
    },
    {
      key: 'DstState',
      name: ' وضعیت مقصد',
      width: '15%'
    },
    {
      key: 'Description',
      name: ' شرح ',
      width: '30%'
    },
    {
      key: 'UserChanger',
      name: ' انجام دهنده ',
      width: '15%'
    },
    {
      key: 'StateDateTime',
      name: ' تاریخ و ساعت  ',
      width: '15%',
      formatter(props) {
        return <span style={{direction : 'rtl'}}>{props.row.StateDateTime.toString()}</span>
      }
    }
  ];
  
console.log("SELECTED RX");
console.log(rxOrder);

const onPrintClicked = (e) =>{

  console.log(process.env.REACT_APP_REPORT_URL);
  var baseAdsress = getReportURL();//process.env.REACT_APP_REPORT_URL;//'http://80.210.21.25:81';
  var reportName = 'RXOrder';
  var up = authUser.username+'$'+encodeURIComponent(authUser.password);
  var ul = baseAdsress+"/Home/PDFReportPage2?reportname="+reportName+"&SelectedValue="+rxOrder.selectedRXOrderId+"&hash="+up
  console.log("URL id");
  console.log(ul);
  const link = document.createElement('a');
  link.setAttribute('target', '_blank');
  link.href = ul;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}


const handleDenyOrder = (e) =>{
  setOpenDeny(true);
}
const handleApproveOrder = (e) =>{
  setOpenApprove(true);
}
const handleYesDeny = (e) =>{
  setOpenDeny(false);
  dispatch(ChangeRXOrderState({ newState : "رد_شده", rxOrder : rxOrder , authUser}));
}
const handleNoDeny = (e) =>{
  setOpenDeny(false);
}

const handleYesApprove = (e) =>{
  setOpenApprove(false);
  dispatch(ChangeRXOrderState({ newState : "در_صف_تولید", rxOrder : rxOrder , authUser}));
}
const handleNoApprove = (e) =>{
  setOpenApprove(false);
}


const handleCloseMessageBox = () =>{
  dispatch(resetRXOrderResultBox());
  navigate(0);
  //navigate('/MyWaitingOrders');
}
const handleSubmitFinalOrder = (e) =>{
  dispatch(setRXOrderPayType(1));
  setOpen(true);

}
const handleSubmitFinalOrderOnlinePayment = (e) =>{
  dispatch(setRXOrderPayType(2));
  setOpen(true);
}

const handleOrderPayment = (e) =>{
  
  dispatch(submitOrderPayment({ rxOrder : rxOrder , authUser}));

}
const handleClosePreviewDialog = (e) =>{

  dispatch(setRXPreviewItemsDialogClose());

}

const handleDescriptionChange = (e) =>{

  dispatch(setRXOrderDescription(e.target.value));

}
const handleStoreNameChange = (e) =>{

  dispatch(setRXOrderStoreName(e.target.value));

}
const handleConsumerChange = (e) =>{

  dispatch(setRXOrderConsumer(e.target.value));

}

function rowKeyGetter(row) {
  return row.RowId;
}

function rowKeyGetterStateHistory(row) {
  return 'His' + row.RowId.toString();
}

function EmptyRowsRenderer() {
  return (
  
    <div style={{ textAlign: 'center', gridColumn: '1/-1' }}>
      {rxOrder.loading ? '' :   ' اطلاعاتی برای نمایش وجود ندارد' }
    </div>
  );
}

 let dataSource  = [];
 //console.log(invoices.selectedInvoice);
 if(rxOrder.previewItems != undefined && rxOrder.previewItems !== undefined && rxOrder.previewItems.length > 0)
 {
     dataSource = rxOrder.previewItems;//.map((item, i) => ({...item, rowIndex : i+1}));
 }

 let dataSourceForStateHistory  = [];
 //console.log(invoices.selectedInvoice);
 if(rxOrder.OrderHistory != undefined && rxOrder.OrderHistory !== undefined && rxOrder.OrderHistory.length > 0)
 {
  dataSourceForStateHistory = rxOrder.OrderHistory;//.map((item, i) => ({...item, rowIndex : i+1}));
 }


return (

<ThemeProvider theme={mdTheme}>
  <div>

    {rxOrder.previewItems != undefined && rxOrder.previewItems !== undefined && rxOrder.previewItems.length > 0 ?  
      <Dialog
        //fullScreen
        sx={{
          "& .MuiDialog-container": {
             alignItems: "flex-start",
          },
       }}
        PaperProps={{
          sx: {
            width: "100%",
            maxWidth: "1400px !important",
            mt: "50px"
          },
        }}
        open={rxOrder.previewItemsDialog}
        //onClose={handleClosePreviewDialog}
        //TransitionComponent={Transition}
        >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <Typography sx={{ ml: 2, flex: 1 }} component="div">
            پیش نمایش سفارش  &nbsp; {rxOrder.number}     
            &nbsp;&nbsp;&nbsp;&nbsp;   
              <Tooltip arrow followCursor title="پرینت سفارش">
                <IconButton onClick={onPrintClicked}>
                            <PrintIcon sx={{ color: '#000000' }}/>
                          </IconButton>
              </Tooltip>
            </Typography>


            <Button autoFocus color="inherit" onClick={handleClosePreviewDialog}>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
         
            </Button>
          </Toolbar>
        </AppBar>

    

        <Box display="flex" justifyContent="center">

          <table dir='ltr' style={{width : '100%'}}>
          <tr>
              <td className='gridBorderData'colSpan={1}><span className='RXPreviewItem'>{rxOrder.emergencyLevel === 2 ? <span style={{backgroundColor : "#ffff00"}}>فوری</span> : "عادی"}</span></td>
              <td className='gridBorderHeader'colSpan={2}><span className='RXPreviewItem'>زمان بندی تولید و تحویل </span></td>
              <td className='gridBorderData' colSpan={4}><span className='RXPreviewItem'>{rxOrder.selectedProductId > 0 ? rxOrder.products.find(r => r.Value == rxOrder.selectedProductId).Name : ''}</span></td>
              <td className='gridBorderHeader'colSpan={3}><span className='RXPreviewItem'>عنوان عدسی</span></td>

            </tr>
            <tr>
              <td className='gridBorder'></td>
              <td className='gridBorderHeader'><span className='RXPreviewItem'>SPH</span></td>
              <td className='gridBorderHeader'><span className='RXPreviewItem'>CYL</span></td>
              <td className='gridBorderHeader'><span className='RXPreviewItem'>AXIS</span></td>
              <td className='gridBorderHeader'><span className='RXPreviewItem'>ADD</span></td>
              <td className='gridBorderHeader'><span className='RXPreviewItem'>DIA</span></td>
              <td className='gridBorderHeader'><span className='RXPreviewItem'>PD</span></td>
              <td className='gridBorderHeader'><span className='RXPreviewItem'>PRISM</span></td>
              <td className='gridBorderHeader'><span className='RXPreviewItem'>BP</span></td>
              <td className='gridBorderHeader'><span className='RXPreviewItem'>DC</span></td>
            </tr>
          
            <tr className='gridBorder'>
              <td className='gridBorderHeader'><span className='RXPreviewItem'>RIGHT</span></td>
              <td className='gridBorderData'><span className='RXPreviewItem'>{rxOrder.RSPHSign === "true" ? "+" : "-"}{rxOrder.RSPH != null ? parseFloat(rxOrder.RSPH).toFixed(2) : rxOrder.RSPH}</span></td>
              <td className='gridBorderData'><span className='RXPreviewItem'>{rxOrder.RCYLSign === "true" ? "+" : "-"}{rxOrder.RCYL != null ? parseFloat(rxOrder.RCYL).toFixed(2) : rxOrder.RCYL}</span></td>
              <td className='gridBorderData'><span className='RXPreviewItem'>{rxOrder.RAXIS}</span></td>
              <td className='gridBorderData'><span className='RXPreviewItem'>{rxOrder.RADD != null ? parseFloat(rxOrder.RADD).toFixed(2) : rxOrder.RADD}</span></td>
              <td className='gridBorderData'><span className='RXPreviewItem'>{rxOrder.RDIA}</span></td>
              <td className='gridBorderData'><span className='RXPreviewItem'>{rxOrder.IPDR}</span></td>
              <td className='gridBorderData'><span className='RXPreviewItem'>{rxOrder.RPrism != null ? parseFloat(rxOrder.RPrism).toFixed(2) : rxOrder.RPrism}</span></td>
              <td className='gridBorderData'><span className='RXPreviewItem'>{rxOrder.RBaseOfPrism}</span></td>
              <td className='gridBorderData'><span className='RXPreviewItem'>{rxOrder.RDC}</span></td>
            </tr>
            <tr className='gridBorder'>
              <td className='gridBorderHeader'><span className='RXPreviewItem'>LEFT</span></td>
              <td className='gridBorderData'><span className='RXPreviewItem'>{rxOrder.LSPHSign === "true" ? "+" : "-"}{rxOrder.LSPH != null ? parseFloat(rxOrder.LSPH).toFixed(2) : rxOrder.LSPH}</span></td>
              <td className='gridBorderData'><span className='RXPreviewItem'>{rxOrder.LCYLSign === "true" ? "+" : "-"}{rxOrder.LCYL != null ? parseFloat(rxOrder.LCYL).toFixed(2) : rxOrder.LCYL}</span></td>
              <td className='gridBorderData'><span className='RXPreviewItem'>{rxOrder.LAXIS}</span></td>
              <td className='gridBorderData'><span className='RXPreviewItem'>{rxOrder.LADD != null ? parseFloat(rxOrder.LADD).toFixed(2) : rxOrder.LADD}</span></td>
              <td className='gridBorderData'><span className='RXPreviewItem'>{rxOrder.LDIA}</span></td>
              <td className='gridBorderData'><span className='RXPreviewItem'>{rxOrder.IPDL}</span></td>
              <td className='gridBorderData'><span className='RXPreviewItem'>{rxOrder.LPrism != null ? parseFloat(rxOrder.LPrism).toFixed(2) : rxOrder.LPrism}</span></td>
              <td className='gridBorderData'><span className='RXPreviewItem'>{rxOrder.LBaseOfPrism}</span></td>
              <td className='gridBorderData'><span className='RXPreviewItem'>{rxOrder.LDC}</span></td>
            </tr>
            <tr className='gridBorder'>
              <td className='gridBorderHeader'><span className='RXPreviewItem'>HBOX</span></td>
              <td className='gridBorderHeader'><span className='RXPreviewItem'>VBOX</span></td>
              <td className='gridBorderHeader'><span className='RXPreviewItem'>SEG-R/FITTING-R</span></td>
              <td className='gridBorderHeader'><span className='RXPreviewItem'>SEG-L/FITTING-L</span></td>
              <td className='gridBorderHeader'><span className='RXPreviewItem'>DBL</span></td>
              <td className='gridBorderHeader'><span className='RXPreviewItem'>ED</span></td>
              <td className='gridBorderHeader'><span className='RXPreviewItem'>PA</span></td>
              <td className='gridBorderHeader'><span className='RXPreviewItem'>FFA</span></td>
              <td className='gridBorderHeader'><span className='RXPreviewItem'>BVD</span></td>
              <td className='gridBorderHeader'><span className='RXPreviewItem'>BASE</span></td>
            </tr>
            <tr className='gridBorder'>
              <td className='gridBorderData'><span className='RXPreviewItem'>{rxOrder.HBOX}</span></td>
              <td className='gridBorderData'><span className='RXPreviewItem'>{rxOrder.VBOX}</span></td>
              <td className='gridBorderData'><span className='RXPreviewItem'>{rxOrder.FITTINGR}</span></td>
              <td className='gridBorderData'><span className='RXPreviewItem'>{rxOrder.FITTINGL}</span></td>
              <td className='gridBorderData'><span className='RXPreviewItem'>{rxOrder.DBL}</span></td>
              <td className='gridBorderData'><span className='RXPreviewItem'>{rxOrder.ED}</span></td>
              <td className='gridBorderData'><span className='RXPreviewItem'>{rxOrder.PANTO}</span></td>
              <td className='gridBorderData'><span className='RXPreviewItem'>{rxOrder.FFA}</span></td>
              <td className='gridBorderData'><span className='RXPreviewItem'>{rxOrder.BVD}</span></td>
              <td className='gridBorderData'><span className='RXPreviewItem'>{rxOrder.selectedBase}</span></td>
            </tr>
            <tr className='gridBorder'>
              <td className='gridBorderHeader' colSpan={2}><span className='RXPreviewItem'>Coating</span></td>
              <td className='gridBorderHeader' colSpan={2}><span className='RXPreviewItem'>مشخصات عدسی قبلی</span></td>
              <td className='gridBorderHeader' colSpan={3}><span className='RXPreviewItem'>Coloring</span></td>
              <td className='gridBorderHeader' colSpan={2}><span className='RXPreviewItem'>نوع فریم </span></td>
              <td className='gridBorderHeader' colSpan={3}><span className='RXPreviewItem'>Corridor</span></td>
            </tr>  
            <tr className='gridBorder'>
              <td className='gridBorderData' colSpan={2}><span className='RXPreviewItem'>{rxOrder.selectedCoatingId > 0 && rxOrder.coatings.find(r => r.Value == rxOrder.selectedCoatingId) !== undefined ? rxOrder.coatings.find(r => r.Value == rxOrder.selectedCoatingId).Name : rxOrder.selectedCoatingName}</span></td>
              {/* <td className='gridBorderData' colSpan={2}><span className='RXPreviewItem'>{rxOrder.selectedCoatingId > 0 ? rxOrder.coatings.find(r => r.Value == rxOrder.selectedCoatingId).Name : ''}</span></td> */}
              {/*<td className='gridBorderData' colSpan={2}><span className='RXPreviewItem'>{rxOrder.selectedCoatingName}</span></td>*/}
              <td className='gridBorderData' colSpan={2}><span className='RXPreviewItem'>{rxOrder.oldLens}</span></td>
              <td className='gridBorderData' colSpan={3}><span className='RXPreviewItem'>{rxOrder.selectedColoringType !== null ? rxOrder.coloringTypes.map(x => ({ id: x.Value, label: x.Name })).find(r => r.id == rxOrder.selectedColoringType).label : ''}&nbsp;-&nbsp;{rxOrder.selectedColor !== null && rxOrder.selectedColor !== undefined && rxOrder.selectedColor !== "" ? rxOrder.colors.find(r => r.Value == rxOrder.selectedColor).Name : ''}&nbsp;-&nbsp;{rxOrder.colorRate === null ? '' : rxOrder.colorRate.toString()+'%'}&nbsp;-&nbsp;{rxOrder.colorRateTop === null ? '' : 'Top '+rxOrder.colorRateTop.toString()+'%'}&nbsp;-&nbsp;{rxOrder.colorRateBottom === null ? '' : 'Bottom '+rxOrder.colorRateBottom.toString()+'%'}</span></td>
              <td className='gridBorderData' colSpan={2}><span className='RXPreviewItem'>{rxOrder.selectedFrameType !== null ? rxOrder.FrameTypes.find(r => r.Value == rxOrder.selectedFrameType).Name : ''}</span></td>
              <td className='gridBorderData' colSpan={3}><span className='RXPreviewItem'>{rxOrder.selectedCorridor} </span></td>
            </tr>  
            <tr className='gridBorder'>
              <td className='gridBorderHeader' colSpan={3}><span className='RXPreviewItem'>توضیحات</span></td>
              <td className='gridBorderHeader' colSpan={2}><span className='RXPreviewItem'>مشتری</span></td>
              <td className='gridBorderHeader' colSpan={2}><span className='RXPreviewItem'>مصرف کننده  </span></td>
              <td className='gridBorderHeader' colSpan={2}><span className='RXPreviewItem'>فروشگاه</span></td>
              <td className='gridBorderHeader' colSpan={2}><span className='RXPreviewItem'>خدمات</span></td>

            </tr>  
            <tr className='gridBorder'>
              <td className='gridBorderData' colSpan={3}><span className='RXPreviewItem'>{rxOrder.description}</span></td>
              <td className='gridBorderData' colSpan={2}><span className='RXPreviewItem'>{rxOrder.customerPortalUserId !== undefined && rxOrder.customerPortalUserId !== null && rxOrder.customerPortalUserId !== "" && authUser.underControlUsers.find(r => r.Value == rxOrder.customerPortalUserId) ? authUser.underControlUsers.find(r => r.Value == rxOrder.customerPortalUserId).Code : ''}</span></td>
              <td className='gridBorderData' colSpan={2}><span className='RXPreviewItem'>{rxOrder.consumer}</span></td>
              <td className='gridBorderData' colSpan={2}><span className='RXPreviewItem'>{rxOrder.storeName}</span></td>
              <td className='gridBorderData' colSpan={2}><span className='RXPreviewItem'>
                {rxOrder.selectedExtraServices.length > 0 ? rxOrder.selectedExtraServices.map((x) => x.label).join('-') : rxOrder.service}
              </span>
              </td>

            </tr>  
          </table>
        </Box>


{rxOrder.OrderHistory != undefined && rxOrder.OrderHistory !== undefined && rxOrder.OrderHistory.length > 0 ?
        <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          sx={{ bgcolor: '#bbdefb'}}
          >
            <Typography sx={{ width: '33%', flexShrink: 0 }}>
            <img src={historyicon} style={{float: 'right'}}/>&nbsp;&nbsp;تاریخچه سفارش </Typography>
         
        </AccordionSummary>
        <AccordionDetails>
        <DataGrid 
        fullWidth
        renderers={{ noRowsFallback: <EmptyRowsRenderer /> }}
        direction="rtl" 
        columns={stateHistoryCols} 
        rows={dataSourceForStateHistory} 
        rowKeyGetter={rowKeyGetterStateHistory}
        //style={{height : dynamicHeight}}
        />
        </AccordionDetails>
      </Accordion>
      
      : ""}

        <Accordion defaultExpanded={false}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
          sx={{ bgcolor: '#bbdefb'}}
          >
            <Typography sx={{ width: '33%', flexShrink: 0 }}>
            <img src={moneyicon} style={{float: 'right'}}/>&nbsp;&nbsp;مبالغ فاکتور</Typography>
         
        </AccordionSummary>
        <AccordionDetails>
        <DataGrid 
        fullWidth
        renderers={{ noRowsFallback: <EmptyRowsRenderer /> }}
        direction="rtl" 
        columns={columns} 
        rows={dataSource} 
        rowKeyGetter={rowKeyGetter}
        //style={{height : dynamicHeight}}
        />

<Grid container 
                    spacing={{ xs: 1, md: 1 }} 
                    columns={{ xs: 4, sm: 8, md: 12 }}
                    direction={{ xs: 'column', sm : 'row-reverse' , md: 'row-reverse' , lg : 'row-reverse'}}
                    >
                          <Grid item xs={12} sm={12} md={12} lg={12} key={390} >
                          <Box sx={{ flexGrow: 1 }} textAlign='left'>
                          <table style={{width : '250px'}}>
  <tr>
  <td className='tdTableRowForOrderPreviewPriceRight'>مبلغ کل </td>
  <td className='tdTableRowForOrderPreviewPriceLeft'>{addComma(rxOrder.previewItems.reduce((n, r ) => n + (r.Quantity * r.Fee), 0).toString())}</td>
  </tr>
{authUser.role === "CustomerPortal" || authUser.role === "Personnel" || authUser.role === "FinancialPersonnel" ? 
  <tr >
  <td className='tdTableRowForOrderPreviewPriceRight'>تخفیف کل</td>
  <td className='tdTableRowForOrderPreviewPriceLeft'>{addComma(rxOrder.previewItems.reduce((n, {Discount}) => n + Discount, 0).toString())}</td>
    </tr>
: ""}
    <tr >
    <td className='tdTableRowForOrderPreviewPriceRight'>قابل پرداخت</td>
  <td className='tdTableRowForOrderPreviewPriceLeft'>{addComma(rxOrder.previewItems.reduce((n, {Price}) => n + Price, 0).toString())}</td>
    </tr>
</table>
                          </Box>
                          </Grid>
                      </Grid>

        </AccordionDetails>
          </Accordion>


          {rxOrder.readOnly ? "" : 
          <span>
                      <Tooltip title="ثبت سفارش">

                      <Button color="success" className='mmgBtnSubmit'
 disabled={!((rxOrder.LSPH !== null) || (rxOrder.RSPH !== null))}
onClick={handleSubmitFinalOrder} variant="outlined" startIcon={<BeenhereIcon />}>
ثبت نهایی سفارش
</Button>

</Tooltip>
{authUser.username === "test" ?
<span>
<span>
<Tooltip title="ثبت سفارش و پرداخت">

<Button color="success" className='mmgBtnSubmit'
disabled={!((rxOrder.LSPH !== null) || (rxOrder.RSPH !== null))}
onClick={handleSubmitFinalOrderOnlinePayment} variant="outlined" startIcon={<BeenhereIcon />}>
ثبت سفارش و پرداخت
</Button>

</Tooltip> 
</span>
<span>
  {rxOrder.orderState === "در_انتظار_پرداخت"? 
  <Tooltip title="پرداخت سفارش">

  <Button color="success" className='mmgBtnSubmit' disabled={rxOrder.items <= 0} onClick={handleOrderPayment} variant="outlined" startIcon={<BeenhereIcon />}>
 پرداخت سفارش
  </Button>
  
  </Tooltip>
  : ""}
</span>
</span>
: ""
}
</span>
}
{rxOrder.orderState === "در_انتظار" && ( authUser.role === "CustomerPortal" || authUser.role === "FinancialPersonnel" ) ? 

<Box sx={{ flexGrow: 1 }} textAlign='center'>
     
     <Grid container>
              <Grid item xs={12}>
                      <Tooltip title="تایید سفارش">
                      <Button color="success" className='mmgBtnSubmit'
 disabled={rxOrder.loading}
onClick={handleApproveOrder} variant="outlined" startIcon={<BeenhereIcon />}>
تایید سفارش
</Button>

</Tooltip>

<Tooltip title="رد سفارش">

<Button color="error" className='mmgBtnSubmit'
disabled={rxOrder.loading}
onClick={handleDenyOrder} variant="outlined" startIcon={<CloseIcon />}>
رد سفارش
</Button>

</Tooltip> </Grid></Grid></Box> : ""
}



          {rxOrder.loading ?   <div className="LoadingDiv">در حال تبادل اطلاعات <LinearProgress color="inherit" /></div>: "" }
              <Dialog
              open={open}
              //onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {"تایید "}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                 آیا از ثبت نهایی سفارش اطمینان دارید؟
                </DialogContentText>
              </DialogContent>
              <DialogActions>
              <Button variant="contained" color='success' startIcon={<CheckIcon />} onClick={handleYes}>
                بله
              </Button>
              <Button variant="contained" color='error' startIcon={<CancelIcon/>} onClick={handleNo}>
                خیر
              </Button>         
              </DialogActions>
            </Dialog>


            <Dialog
              open={openDeny}
              //onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {"تایید "}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                 آیا از رد سفارش اطمینان دارید؟
                </DialogContentText>
              </DialogContent>
              <DialogActions>
              <Button variant="contained" color='success' startIcon={<CheckIcon />} onClick={handleYesDeny}>
                بله
              </Button>
              <Button variant="contained" color='error' startIcon={<CancelIcon/>} onClick={handleNoDeny}>
                خیر
              </Button>           
              </DialogActions>
            </Dialog>


            <Dialog
              open={openApprove}
              //onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {"تایید "}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                 آیا از تایید نهایی سفارش اطمینان دارید؟
                </DialogContentText>
              </DialogContent>
              <DialogActions>
              <Button variant="contained" color='success' startIcon={<CheckIcon />} onClick={handleYesApprove}>
                بله
              </Button>
              <Button variant="contained" color='error' startIcon={<CancelIcon/>} onClick={handleNoApprove}>
                خیر
              </Button>
            

              </DialogActions>
            </Dialog>

      </Dialog>
      : ''}
      </div>
  
      <Dialog
              open={rxOrder.boxType > 0}
              //onClose={handleCloseMessageBox}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
             >
              <DialogTitle id="alert-dialog-title">
                {"نتیجه عملیات"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                <Alert severity={rxOrder.boxType === 1 ? "error" : (rxOrder.boxType === 2 ? "success" : "info")}>
                <Typography
                    variant="span"
                    color="primary"
                    dangerouslySetInnerHTML={{ __html: rxOrder.boxMessage }}>
                    
                </Typography>
             
                  </Alert>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
               <Button variant="contained" color='error' onClick={handleCloseMessageBox}>
                     خب
              </Button>
              </DialogActions>
            </Dialog>


    </ThemeProvider>

  );
}

export default RXPreviewItems;